import * as ActionTypes from "../../../actions/actionTypes";
import { forgotPasswordState } from "../../../states/userStates";

const forgotPasswordReducer = (state = forgotPasswordState, action) => {
  switch (action.type) {

    case ActionTypes.USER_FORGOT_PASSWORD:
      return {
        ...state,
        payload: action.payload,
        isSuccessful: false,
        error: false,
      };

    case ActionTypes.USER_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        payload: action.payload,
        isSuccessful: true,
        error: false,
      };

    case ActionTypes.USER_FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        payload: action.payload,
        isSuccessful: false,
        error: true,
      };

    default:
      return state;
  }
};

export default forgotPasswordReducer;